module.exports = __webpack_public_path__ + "img/icon-error@3x.c36b0278.png";